<template>
  <div
    v-if="props.brandData && props.brandData.length > 0"
    class="max-md:mt-16"
  >
    <TsGrid :cols="4" :mobileCols="2" :tabletCols="3" :space="4">
      <TransitionGroup name="animatedlist">
        <div class="parent-container" v-for="item in props.brandData" :key="item.brand?.id || `brand-${item.brand?.title}`">
          <TsColumn class="cursor-pointer" v-if="item.brand" >
            <NuxtLinkWithLocale
              :to="getBrandSlug(item.brand.title)"
              @click="handleImageLinkClick()"
              :data-testid="`blp-link-to-/merk/${item.brand.title.toLowerCase()}`"
            >
              <TsImage
                v-if="item.brand && item.brand.image"
                :src="item.brand.image"
                :alt="item.brand.title"
                width="288"
                height="85"
                :class="[twMerge(' w-full', props.imageClass)]"
                loading="lazy"
              />
            </NuxtLinkWithLocale>
          </TsColumn>
        </div>
      </TransitionGroup>
    </TsGrid>
  </div>
  <div v-else>
    <TsTypography variant="p" as="h2" align="center">
      {{ useTranslation("noBrandFound", "Geen overeenkomst gevonden") }}
    </TsTypography>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { EventConstants } from "~/assets/constants/ecomApi";

const authStore = useAuthStore();
const rootStore = useRootStore();
const branchStore = useBranchStore();
const route = useRoute();

const TsGrid = defineAsyncComponent(
  () => import("~/components/organisms/TsGrid.vue")
);

function handleImageLinkClick()
{
  const user = authStore.user;
  logEvent({
    options: {
      eventAction: "click",
      eventProperties: {
        user: authStore.is_authenticated
                ? {
                    user_id: user.id,
                    email: user.email,
                    phone: user.mobile,
                    order_count: user.order_count,
                    order_value: user.order_value,
                    account_type: user.account_type,
                  }
                : "User is not Logged In",
                    page: {
              page_url: window.location.href,
              page_path: route.fullPath,
              page_referrer: document.referrer,
              page_title: document.title,
              content_group: "",
              content_group2: "",
            },
              site: {
                shop_language: "",
                shop_currency: EventConstants.currency,
                tax_toggle: rootStore.isIncVat ? "INC" : "EX",
                selected_branche: branchStore.currentSavedBranch?.id,
              },
      },
      eventInteraction: true,
      eventLabel: `brand_navigation`,
      eventName: "brand_navigation",
    },
  });
}

const props = defineProps({
  brandData: <any>{
    type: Array,
    // default: data,
    required: false,
  },
  heading: {
    type: String,
    default: "Explore Our Popular Brands",
    required: false,
  },
  showCards: {
    type: Number,
    default: 8,
    required: false,
  },
  wrapperClass: {
    type: String,
    required: false,
  },
  imageWrapperClass: {
    type: String,
    required: false,
  },
  imageClass: {
    type: String,
    required: false,
  },
  headingClass: {
    type: String,
    required: false,
  },
  dataTestId: {
    type: String,
  },
});
</script>
